import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap'
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTh } from '@fortawesome/free-solid-svg-icons'
import { faList } from '@fortawesome/free-solid-svg-icons'
import Header from '../Header/Header';
import PageBanner from '../page-banner/page-banner';
import ToggleSwitch from '../../Modals/ToggleSwitch';
import FramItem from '../farm-item/farm-item';

import "./farms.css";

const options = [
    { value: 'HOT', label: 'HOT' },
    { value: 'APR', label: 'APR' },
    { value: 'Multiplier', label: 'Multiplier' },
	{ value: 'Earned', label: 'Earned' },
	{ value: 'Liquidity', label: 'Liquidity' },
];

function Farms() {
	const [option, setOption] = useState({ value: 'HOT', label: 'HOT' })
	const handleChange = (selectedOption) => {
        setOption(selectedOption);
        console.log(`Option selected:`, selectedOption);
    };
	return (
		<>
			<Header />
			<section className="earn-section">
				<PageBanner title="Farms" subHeading="Stake LP tokens to earn" />
			</section>
			<section className="earn-content">
				<div className="filters-row py-4 py-md-5 mb-4 mb-md-5">
					<Container>
						<Row className="align-items-end">
							<Col lg="6">
								<div className="d-flex justify-content-between mb-3 mb-lg-0 flex-column flex-sm-row">
									<div className="d-flex align-items-center">
										<div className="icons-holder">
											<ul className="list-unstyled d-flex mb-0">
												<li className="me-3 cur-poi active"><FontAwesomeIcon icon={faTh} /></li>
												<li className="me-3 cur-poi"><FontAwesomeIcon icon={faList} /></li>
											</ul>
										</div>
										<div className="toggle-holder">
											<ToggleSwitch toggleText="Staked only"/>
										</div>
									</div>
									<div className="tabs-holder pt-2 pt-sm-0">
										<ul className="list-unstyled tabs-list mb-0 d-flex justify-content-start justify-content-sm-end">
											<li className="ms-0 ms-sm-3 me-3 me-sm-0">
												<label className="custom-radio">
													<input type="radio" name="live-finshed" />
													<span className="custom-radio-text">Live</span>
													<span className="checkmark"></span>
												</label>
											</li>
											<li className="ms-0 ms-sm-3 me-3 me-sm-0">
												<label className="custom-radio">
													<input type="radio" name="live-finshed" />
													<span className="custom-radio-text">Finished</span>
													<span className="checkmark"></span>
												</label>
											</li>
										</ul>
									</div>
								</div>
							</Col>
							<Col lg="6">
								<div className="search-sort-form d-flex justify-content-between justify-content-lg-end flex-column flex-sm-row">
									<Form.Group className="ms-0 ms-lg-3 mb-2 mb-sm-0">
										<label className="text-uppercase">Sort By</label>
										<div className="select-holder">
											<Select id="color"
												value={option}
												onChange={() => handleChange()}
												classNamePrefix="mySelect"
												options={options}
											/>
										</div>
									</Form.Group>
									<Form.Group className="ms-0 ms-sm-3">
										<label className="text-uppercase">Search</label>
										<div className="input-holder">
											<input type="text" placeholder="Search Farms" />
										</div>
									</Form.Group>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
				<div className="farms-holder">
					<Container>
						<Row>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
							<Col lg={4} md={6}>
								<FramItem />
							</Col>
						</Row>
					</Container>
				</div>
			</section>
		</> 
	);
}

export default Farms;
